import { BONUS_SPEND_TIER_COUNT, BonusSpendMissionTier } from "../store/types"

export type BonusMissionsValidationError =
  | { kind: "count"; message: string }
  | { kind: "levels"; message: string }
  | { kind: "threshold"; level: number; message: string }
  | { kind: "reward"; level: number; message: string }

export const validateBonusTiers = (
  tiers: BonusSpendMissionTier[],
): BonusMissionsValidationError | null => {
  if (tiers.length !== BONUS_SPEND_TIER_COUNT) {
    return {
      kind: "count",
      message: `Exactly ${BONUS_SPEND_TIER_COUNT} tiers are required (got ${tiers.length})`,
    }
  }

  const sorted = [...tiers].sort((a, b) => a.level - b.level)
  const expectedLevels = Array.from({ length: BONUS_SPEND_TIER_COUNT }, (_, idx) => idx + 1)
  const actualLevels = sorted.map(t => t.level)
  if (actualLevels.join(",") !== expectedLevels.join(",")) {
    return {
      kind: "levels",
      message: `Tiers must cover levels ${expectedLevels.join(",")} exactly once; got ${actualLevels.join(",")}`,
    }
  }

  for (const tier of sorted) {
    if (!(tier.rewardUsd > 0)) {
      return {
        kind: "reward",
        level: tier.level,
        message: `Reward (level ${tier.level}) must be greater than 0`,
      }
    }
  }

  for (let i = 1; i < sorted.length; i += 1) {
    const prev = sorted[i - 1]
    const curr = sorted[i]
    if (!(curr.spendThresholdUsd > prev.spendThresholdUsd)) {
      return {
        kind: "threshold",
        level: curr.level,
        message: (
          `Spend threshold for level ${curr.level} (${curr.spendThresholdUsd}) `
          + `must be greater than level ${prev.level} (${prev.spendThresholdUsd})`
        ),
      }
    }
  }

  return null
}
